import _ from 'lodash'

export default class LanguageService {

  static getViewerLanguage() {
    return _.get(window, 'localStorage.viewerLanguage',"en")
  }

  static setViewerLanguage(language) {
    window.localStorage.setItem('viewerLanguage', language);
  }

  static clearViewerLanguage(){
    window.localStorage.removeItem('viewerLanguage');
  }

}